/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";
export default class PsychologyHistorialService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(
      ServiceConstant.PSYCHOLOGY_LISTATTEND_PAGINATION,
      params
    );
  }
  static get(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_GET_HISTORIAL, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_UPDATE, params);
  }

  static pdf(params) {
    return this.postPDFSEC(ServicePath.PSYCHOLOGY_PDF, params);
  }
  static excel(params) {
    return this.postPDFSEC(ServiceConstant.PSYCHOLOGY_EXCEL, params);
  }
}
